<template>
  <section id="about" class="about">
    <div>
      <div class="section-title">
        <h2>學生專題競賽獲獎(Student Special Awards)</h2>
      </div>
      <hr />
      <h2 class="studentawards-title">115年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="(item1, index) in contest115"
        :key="item1.num"
      >
        <a class="ct1">{{ index + 1 }}. </a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">114年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="(item1, index) in contest114"
        :key="item1.num"
      >
        <a class="ct1">{{ index + 1 }}. </a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">113年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="(item1, index) in contest113"
        :key="item1.num"
      >
        <a class="ct1">{{ index + 1 }}. </a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">112年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="(item1, index) in contest112"
        :key="item1.num"
      >
        <a class="ct1">{{ index + 1 }}. </a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">111年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest111"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">110年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest110"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2" :href="item1.path" target="_blank">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">109年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest109"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">108年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest108"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">107年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest107"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">106年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest106"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">105年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest105"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">104年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest104"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">103年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest103"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">102年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest102"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">101年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest101"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">100年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest100"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">99、98年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest9899"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">97年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest97"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
      <hr />
      <h2 class="studentawards-title">95、96年專題製作與競賽</h2>
      <hr />
      <p
        class="studentawards-content"
        v-for="item1 in contest9596"
        :key="item1.num"
      >
        <a class="ct1">{{ item1.num }}</a>
        <a class="ct2">{{ item1.name }}</a>
        <a class="ct3">{{ item1.student_name }}</a>
        <a class="ct4">{{ item1.awards }}</a>
      </p>
    </div>
  </section>
</template>

<script>
import { awardsPath_110 } from "../assets/studentAwardsRouter/studentAwards_110";
import { awardsPath_111 } from "../assets/studentAwardsRouter/studentAwards_111";
import { awardsPath_112 } from "../assets/studentAwardsRouter/studentAwards_112";
import { awardsPath_113 } from "../assets/studentAwardsRouter/studentAwards_113";
import { awardsPath_114 } from "../assets/studentAwardsRouter/studentAwards_114";
import { awardsPath_115 } from "../assets/studentAwardsRouter/studentAwards_115";
export default {
  name: "sudentAward",
  data() {
    return {
      //115年專題製作與競賽
      contest115:[
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:林承邑)",
      awards: "資訊(計算機) 獲得冠軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[18],
      },
	    {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:楊朋展)",
      awards: "電競 獲得冠軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[17],
      },
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:張景淳)",
      awards: "電機與電子 獲得冠軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[16],
      },    
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:張善銓)",
      awards: "教育 獲得冠軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[15],
      },    
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:余牧學)",
      awards: "教育 獲得亞軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[14],
      },
	    {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:吳欣樺)",
      awards: "人工智慧 獲得季軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[13],
      },
	    {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:李宣緯)",
      awards: "數位多媒體 獲得亞軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[12],
      },
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:陳邑嘉)",
      awards: "電競 獲得亞軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[11],
      },
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:朱家葦)",
      awards: "人工智慧 獲得亞軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[10],
      },
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:黃晶蘋)",
      awards: "人工智慧 獲得冠軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[9],
      },
      {
      name: "2026年第九屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:雷凱婷)",
      awards: "數位多媒體 獲得冠軍, 2026/06/05 GLAD/台師大/臺中家商)",
      path: awardsPath_115[8],
      },
      {
      name: "2026 年技職杯黑客松競賽",
      student_name: "(選手:張為嘉、顏御家、符致榮)",
      awards: "(中區分區賽 獲得最佳創造價值獎, 2026/05/10 高雄科大/虎尾科大)",
      path: awardsPath_115[7],
      },
      {
      name: "2026 第 38 屆 AERC 亞洲智慧型機器人大賽",
      student_name: "(選手:林承邑、張景淳、張善銓)",
      awards: "(A06 輪型機器人軌道挑戰 大專院校D組 獲得第一名, 2026/05/09 AERC/勤益科大)",
      path: awardsPath_115[6],
      },
      {
      name: "2026 TIRC 台灣智慧型機器人大賽",
      student_name: "(選手:林承邑、陳邑嘉、張善銓)",
      awards: "(A1U競速接力自走循跡車競賽大專組 獲得第二名, 2026/03/07 AERC/勤益科大)",
      path: awardsPath_115[5],
      },
      {
      name: "2025 第十四屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:林承邑)",
      awards: "(全國-總決賽教育類季軍, 2026/01/27 GLAD/台師大/黎明技術學院)",
      path: awardsPath_115[4],
      },
      {
      name: "2025 第十四屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:楊朋展)",
      awards: "(全國-總決賽資訊(計算機)類亞軍, 2026/01/27 GLAD/台師大/黎明技術學院)",
      path: awardsPath_115[3],
      },
      {
      name: "2025 第十四屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:張景淳)",
      awards: "(全國-總決賽電競類亞軍, 2026/01/27 GLAD/台師大/黎明技術學院)",
      path: awardsPath_115[2],
      },
      {
      name: "2025 第十四屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:黃晶蘋)",
      awards: "(全國-總決賽資訊(計算機)類季軍, 2026/01/27 GLAD/台師大/黎明技術學院)",
      path: awardsPath_115[1],
      },
      {
      name: "2025 第十四屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:雷凱婷)",
      awards: "(全國-總決賽人工智慧類季軍, 2026/01/27 GLAD/台師大/黎明技術學院)",
      path: awardsPath_115[0],
      }
      ],
      //114年專題製作與競賽
      contest114:[
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:林承邑)",
        awards: "(全國賽-中區決賽教育亞軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[19],
      },  
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:張景淳)",
        awards: "(全國賽-中區決賽電競冠軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[18],
      }, 
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:雷凱婷)",
        awards: "(全國賽-中區決賽人工智慧冠軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[17],
      },     
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:李宣緯)",
        awards: "(全國賽-中區決賽人工智慧亞軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[16],
      },    
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:楊朋展)",
        awards: "(全國賽-中區決賽數位多媒體冠軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[15],
      },
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:張善銓)",
        awards: "(全國賽-中區決賽數位多媒體亞軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[14],
      },
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:余牧學)",
        awards: "(全國賽-中區決賽數位多媒體亞軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[13],
      },
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:黃晶蘋)",
        awards: "(全國賽-中區決賽資訊類(計算機)冠軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[12],
      },
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:吳欣樺)",
        awards: "(全國賽-中區決賽資訊類(計算機)亞軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[11],
      },
      {
        name: "2025 第十四屆 專業英日文詞彙(ESP)與聽寫說能力大賽",
        student_name: "(選手:朱家葦)",
        awards: "(全國賽-中區決賽資訊類(計算機)亞軍,2025/11/25 GLAD/台師大/中臺科大)",
        path: awardsPath_114[10],
      },
      {
      name: "2025 第 37 屆 AERC 亞洲智慧型機器人大賽",
      student_name: "(選手:林承邑、張善銓、陳邑嘉)",
      awards: "(C06 輪型機器人軌道挑戰 大專院D組 獲得第二名, 2025/11/22 AERC/勤益科大)",
      path: awardsPath_114[9],
      },
      {
      name: "2025 第 36 屆 AERC 亞洲智慧型機器人大賽",
      student_name: "(選手:楊朋展、陳邑嘉、詹竣森)",
      awards: "(C06 輪型機器人軌道挑戰 大專院校C組 獲得佳作, 2025/06/14 AERC/勤益科大)",
      path: awardsPath_114[8],
      },
      {
      name: "2025 第 36 屆 AERC 亞洲智慧型機器人大賽",
      student_name: "(選手:林承邑、張景淳、張善銓)",
      awards: "(C06 輪型機器人軌道挑戰 大專院校C組 獲得佳作, 2025/06/14 AERC/勤益科大)",
      path: awardsPath_114[7],
      },
      {
      name: "2025年第八屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:張善銓)",
      awards: "(人工智慧 獲得冠軍 , 2025/05/09 GLAD/台師大/豐原高商)",
      path: awardsPath_114[6],
      },
      {
      name: "2025年第八屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:張景淳)",
      awards: "(教育 獲得冠軍 , 2025/05/09 GLAD/台師大/豐原高商)",
      path: awardsPath_114[5],
      },
      {
      name: "2025年第八屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:楊朋展)",
      awards: "(資訊(計算機) 獲得冠軍 , 2025/05/09 GLAD/台師大/豐原高商)",
      path: awardsPath_114[4],
      },
      {
      name: "2025年第八屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
      student_name: "(選手:林承邑)",
      awards: "(數位多媒體 獲得季軍 , 2025/05/09 GLAD/台師大/豐原高商)",
      path: awardsPath_114[3],
      },
      {
      name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:張善銓)",
      awards: "(全國-全國賽資訊類(計算機)類金腦獎, 2025/1/21 GLAD/台師大/黎明技術學院)",
      path: awardsPath_114[2],
      },
      {
      name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:張景淳)",
      awards: "(全國-全國賽數位多媒體設計類冠軍, 2025/1/21 GLAD/台師大/黎明技術學院)",
      path: awardsPath_114[1],
      },
      {
      name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
      student_name: "(選手:林承邑)",
      awards: "(全國-全國賽人工智慧類金腦獎, 2025/1/21 GLAD/台師大/黎明技術學院)",
      path: awardsPath_114[0],
      }
      ],
      //113年專題製作與競賽
      contest113:[
      {
        name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:張景淳)",
        awards: "(全國-中區賽數位多媒體設計類冠軍,2024/11/30 GLAD/台師大/中臺科大)",
        path: awardsPath_113[awardsPath_113.length-19],
      },
      {
        name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:張善銓)",
        awards: "(全國-中區賽資訊類(計算機)冠軍,2024/11/30 GLAD/台師大/中臺科大)",
        path: awardsPath_113[awardsPath_113.length-18],
      },
      {
        name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:楊朋展)",
        awards: "(全國-全國中區賽人工智慧類冠軍,2024/11/30 GLAD/台師大/中臺科大)",
        path: awardsPath_113[awardsPath_113.length-17],
      },
      {
        name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:胡品淇)",
        awards: "(全國-全國中區賽人工智慧類亞軍,2024/11/30 GLAD/台師大/中臺科大)",
        path: awardsPath_113[awardsPath_113.length-16],
      },
      {
        name: "2024 第十三屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:林承邑)",
        awards: "(全國-全國中區賽人工智慧類冠軍,2024/11/30 GLAD/台師大/中臺科大)",
        path: awardsPath_113[awardsPath_113.length-15],
      },
      {
        name: "2024年第十二屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:游宗穎)",
        awards: "(全國賽-ICT計算機綜合能力 獲得冠軍,2024/05/25 GLAD)",
        path: awardsPath_113[awardsPath_113.length-14],
      },
      {
        name: "2024年第十二屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:陳俞助)",
        awards: "(全國賽-AIL人工智慧素養 獲得亞軍,2024/05/25 GLAD)",
        path: awardsPath_113[awardsPath_113.length-13],
      },
      {
        name: "2024年第十二屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:陳俞助)",
        awards: "(中區賽-MCT元宇宙應用 獲得冠軍,2024/05/25 GLAD)",
        path: awardsPath_113[awardsPath_113.length-12],
      },
      {
        name: "2024年第十二屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:何祐緯)",
        awards: "(中區賽 ICTP計算機程式語言設計能力 獲得冠軍,2024/05/25 GLAD)",
        path: awardsPath_113[awardsPath_113.length-11],
      },
      {
        name: "2024年第十二屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:游宗穎)",
        awards: "(中區賽 ICT計算機綜合能力 獲得冠軍,2024/05/25 GLAD)",
        path: awardsPath_113[awardsPath_113.length-10],
      },
      {
        name: "2024年第十二屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:陳俞助)",
        awards: "(中區賽-AIL人工智慧素養 獲得亞軍,2024/05/25 GLAD)",
        path: awardsPath_113[awardsPath_113.length-9],
      },
      {
        name: "2024年第七屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:游宗穎)",
        awards: "(人工智慧 獲得季軍,2024/05/20 GLAD/台師大/臺中家商)",
        path: awardsPath_113[awardsPath_113.length-8],
      },
      {
        name: "2024年第七屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:温秉勳)",
        awards: "(體育運動 獲得亞軍,2024/05/20 GLAD/台師大/臺中家商)",
        path: awardsPath_113[awardsPath_113.length-7],
      },
      {
        name: "2024年第七屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:陳俞助)",
        awards: "(教育 獲得亞軍,2024/05/20 GLAD/台師大/臺中家商)",
        path: awardsPath_113[awardsPath_113.length-6],
      },
      {
        name: "2024年第七屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:何祐緯)",
        awards: "(教育 獲得冠軍,2024/05/20 GLAD/台師大/臺中家商)",
        path: awardsPath_113[awardsPath_113.length-5],
      },
      {
        name: "2024年第七屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:張景淳)",
        awards: "(資訊(計算機) 獲得冠軍,2024/05/20 GLAD/台師大/臺中家商)",
        path: awardsPath_113[awardsPath_113.length-4],
      },
      {
        name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:張景淳)",
        awards: "(全國-全國賽人工智慧類亞軍,2024/1/24 GLAD/台師大/黎明技術學院)",
        path: awardsPath_113[awardsPath_113.length-3],
      },
      {
        name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:何祐緯)",
        awards: "(全國-全國賽數位多媒體設計類季軍,2024/1/24 GLAD/台師大/黎明技術學院)",
        path: awardsPath_113[awardsPath_113.length-2],
      },
      {
        name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
        student_name: "(選手:陳俞助)",
        awards: "(全國-全國賽數位多媒體設計類季軍,2024/1/24 GLAD/台師大/黎明技術學院)",
        path: awardsPath_113[awardsPath_113.length-1],
      },],
      //112年專題製作與競賽
      contest112:[
      {
          num: "1.",
          name: "2023第五屆技職校院大手攜小手智慧創新應用競賽",
          student_name: "(選手:張景淳、陳政柏、廖心晨、江承勳、李國聿、沈富宥)",
          awards: "(題目:基於碳中和永績目標之智慧温室戰情系統 獲得佳作,112/12/02 僑光科技大學)",
          path: awardsPath_112[25],
      },
      {
          name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:陳俞助)",
          awards: "(全國-中區賽數位多媒體設計類冠軍,2023/11/11 GLAD/台師大/中臺科大)",
          path: awardsPath_112[0],
      },
	    {
          name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:何祐緯)",
          awards: "(全國-中區賽數位多媒體設計類亞軍,2023/11/11 GLAD/台師大/中臺科大)",
          path: awardsPath_112[1],
      },
	    {
          name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:陳政柏)",
          awards: "(全國-中區賽ICT資訊類(計算機)冠軍,2023/11/11 GLAD/台師大/中臺科大)",
          path: awardsPath_112[2],
      },
	    {
          name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:胡品淇)",
          awards: "(全國-中區賽ICT資訊類(計算機)亞軍,2023/11/11 GLAD/台師大/中臺科大)",
          path: awardsPath_112[3],
      },
	    {
          name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:張景淳)",
          awards: "(全國-中區賽人工智慧類亞軍,2023/11/11 GLAD/台師大/中臺科大)",
          path: awardsPath_112[4],
      },
	    {
          name: "2023第十二屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:廖偉鴻)",
          awards: "(全國-中區賽人工智慧類季軍,2023/11/11 GLAD/台師大/中臺科大)",
          path: awardsPath_112[5],
      },
      {
        name: "2023 ACM-ICPC (第六屆全國科技大專校院程式競賽)",
        student_name: "(選手:何祐緯、陳俞助、張景淳)",
        awards: "(獲得銅牌獎, 2023/06/29 虎尾科大)",
        path: awardsPath_112[6],
      },
      {
        num: "1.",
        name: "2023年第十一屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:何祐緯)",
        awards: "(全國賽 ICTP計算機程式語言設計能力 獲得亞軍,2023/06/15 GLAD)",
        path: awardsPath_112[7],
      },
      {
        num: "2.",
        name: "2023年第十一屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:陳俞助)",
        awards: "(全國賽 AIL人工智慧素養 獲得亞軍,2023/06/15 GLAD)",
        path: awardsPath_112[8],
      },
      {
        num: "3.",
        name: "2023年第十一屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:何祐緯)",
        awards: "(中區賽 ICTP計算機程式語言設計能力 獲得冠軍,2023/06/15 GLAD)",
        path: awardsPath_112[9],
      },
      {
        num: "4.",
        name: "2023年第十一屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:張景淳)",
        awards: "(中區賽 ICT計算機綜合能力 獲得冠軍,2023/06/15 GLAD)",
        path: awardsPath_112[10],
      },
      {
        num: "5.",
        name: "2023年第十一屆全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
        student_name: "(選手:陳俞助)",
        awards: "(中區賽 AIL人工智慧素養 獲得亞軍,2023/06/15 GLAD)",
        path: awardsPath_112[11],
      },
      {
        num: "6.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:徐振傑)",
        awards: "(數位多媒體設計 獲得冠軍,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[12],
      },
      {
        num: "7.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:温秉勳)",
        awards: "(數位多媒體設計 獲得亞軍,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[13],
      }, 
      {
        num: "8.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:陳俞助)",
        awards: "(人工智慧 獲得亞軍,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[14],
      }, 
      {
        num: "9.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:何祐緯)",
        awards: "(人工智慧 獲得季軍,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[15],
      }, 
      {
        num: "10.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:曾慶誌)",
        awards: "(人工智慧 獲得金腦獎,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[16],
      }, 
      {
        num: "6.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:黃泓喨)",
        awards: "(教育 獲得季軍,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[17],
      }, 
      {
        num: "7.",
        name: "2023年第六屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
        student_name: "(選手:黃冠勳)",
        awards: "(教育 獲得金腦獎,2023/06/26 GLAD/台師大/豐原高商)",
        path: awardsPath_112[18],
      }, 
      {
        name: "「2023年黑客松：技職盃全國大賽」中區賽",
        student_name: "(選手:何祐緯、温秉勳、曾慶志)",
        awards: "(獲得入圍總決賽,2023/4/30)",
        
      },
      {
        name: "「2023年黑客松：技職盃全國大賽」中區賽",
        student_name: "(選手:陳俞助、黃冠勳、徐振傑)",
        awards: "(獲得入圍總決賽,2023/4/30)",
      },
      {
          num: "8.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:何祐緯)",
          awards: "(全國-全國賽ICT資訊類(計算機)季軍,2023/3/4 GLAD/台師大/黎明技術學院)",
          path: awardsPath_112[19],
        },
        {
          num: "9.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:徐振傑)",
          awards: "(全國-全國賽人工智慧類亞軍,2023/3/4 GLAD/台師大/黎明技術學院)",
          path: awardsPath_112[20],
        },
        {
          num: "10.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:陳俞助)",
          awards: "(全國-全國賽ICT資訊類(計算機)金腦獎,2023/3/4 GLAD/台師大/黎明技術學院)",
          path: awardsPath_112[21],
        },
        {
          num: "11.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:温秉勳)",
          awards: "(全國-全國賽人工智慧類季軍,2023/3/4 GLAD/台師大/黎明技術學院)",
          path: awardsPath_112[22],
        },
        {
          num: "12.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(全國-全國賽多媒體設計類亞軍,2023/3/4 GLAD/台師大/黎明技術學院)",
          path: awardsPath_112[23],
        },
        {
          num: "13.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:鄭郁蓁)",
          awards: "(全國-全國賽多媒體設計類冠軍,2023/3/4 GLAD/台師大/黎明技術學院)",
          path: awardsPath_112[24],
        },
      ],
      //111年專題製作與競賽
      contest111: [
      {
          num: "1.",
          name: "2022第四屆技職校院大手攜小手智慧創新應用競賽",
          student_name: "(選手:胡修瑞、何祐緯、方建木、林永堂、胡佑昇、陳佩臻)",
          awards: "(題目:一種新穎設計智慧溫室低成本散熱系統結合炭循環魚菜共生 獲得季軍,2022/12/03 勤益科大)",
          path: awardsPath_111[30],
        },
      {
          num: "2.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:何祐緯)",
          awards: "(全國-中區賽ICT資訊類(計算機)冠軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[22],
        },
        {
          num: "3.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:陳俞助)",
          awards: "(全國-中區賽ICT資訊類(計算機)亞軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[23],
        },
        {
          num: "4.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:曾慶誌)",
          awards: "(全國-中區賽ICT資訊類(計算機)亞軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[24],
        },
        {
          num: "5.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:温秉勳)",
          awards: "(全國-中區賽人工智慧類冠軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[25],
        },
        {
          num: "6.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(全國-中區賽數位多媒體設計類亞軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[26],
        },
        {
          num: "7.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃冠勳)",
          awards: "(全國-中區賽數位多媒體設計類亞軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[27],
        },
        {
          num: "8.",
          name: "2022第十一屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:鄭郁蓁)",
          awards: "(全國-中區賽數位多媒體設計類冠軍,2022/11/12 GLAD/台師大/建國科大)",
          path: awardsPath_111[28],
        },
        {
          num: "9.",
          name: "AERC 2022 亞洲智慧型機器人大賽",
          student_name: "(選手: 胡修瑞、温秉勳、徐振傑、曾慶誌)",
          awards:
            "(機器人競速挑戰 大專院校組 C組 獲得佳作,2022/07/30 亞洲教育創新與機器人競賽協會)",
          path: awardsPath_111[13],
        },
        {
          num: "10.",
          name: "AERC 2022 亞洲智慧型機器人大賽",
          student_name: "(選手: 藍詠弘、黃士豪、黃泓喨)",
          awards:
            "(機器人障礙挑戰 大專院校組 C組 獲得佳作,2022/07/30 亞洲教育創新與機器人競賽協會)",
          path: awardsPath_111[14],
        },
        {
          num: "11.",
          name: "2022 ACM-ICPC (第五屆全國科技大專校院程式競賽)",
          student_name: "(選手:黃泓喨、黃冠勳、曾慶誌)",
          awards: "(獲得銅牌獎, 2022/06/29 虎尾科大)",
          path: awardsPath_111[12],
        },
        {
          num: "12.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(數位多媒體設計 獲得冠軍,2022/08/02 GLAD/台師大/台中家商)",
          path: awardsPath_111[15],
        },
        {
          num: "13.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:黃士豪)",
          awards: "(人工智慧 獲得冠軍,2022/08/02 GLAD/台師大/台中家商)",
          path: awardsPath_111[16],
        },
        {
          num: "14.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:徐振傑)",
          awards: "(人工智慧 獲得亞軍,2022/08/02 GLAD/台師大/台中家商)",
          path: awardsPath_111[17],
        },
        {
          num: "15.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:藍詠弘)",
          awards: "(人工智慧 獲得季軍,2022/08/02 GLAD/台師大/台中家商",
          path: awardsPath_111[18],
        },
        {
          num: "16.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:黃冠勳)",
          awards: "(資訊(計算機) 獲得冠軍,2022/08/02 GLAD/台師大/台中家商)",
          path: awardsPath_111[19],
        },
        {
          num: "17.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:陳政廷)",
          awards: "(資訊(計算機) 獲得亞軍,2022/08/02 GLAD/台師大/台中家商)",
          path: awardsPath_111[20],
        },
        {
          num: "18.",
          name: "2022年第五屆臺中市英文菁英盃-專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:温秉勳)",
          awards: "(資訊(計算機) 獲得季軍,2022/08/02 GLAD/台師大/台中家商)",
          path: awardsPath_111[21],
        },
        {
          num: "19.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:黃泓喨)",
          awards:
            "(全國賽 ICTP 計算機綜合能力-使用程式語言(Python) 獲得冠軍,2022/06/20 GLAD)",
          path: awardsPath_111[8],
        },
        {
          num: "20.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:黃士豪)",
          awards: "(全國賽 DMT 數位多媒體綜合能力 獲得冠軍,2022/06/20 GLAD)",
          path: awardsPath_111[9],
        },
        {
          num: "21.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:藍詠弘)",
          awards: "(全國賽 AIL 人工智慧素養 獲得季軍,2022/06/20 GLAD)",
          path: awardsPath_111[10],
        },
        {
          num: "22.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:黃泓喨)",
          awards:
            "(中區賽 ICTP 計算機綜合能力-使用程式語言(Python) 獲得冠軍,2022/06/11 GLAD)",
          path: awardsPath_111[1],
        },
        {
          num: "23.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:藍詠弘)",
          awards: "(中區賽 AIL 人工智慧素養 獲得冠軍,2022/06/11 GLAD)",
          path: awardsPath_111[2],
        },
        {
          num: "24.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:黃士豪)",
          awards: "(中區賽 DMT 數位多媒體綜合能力 獲得冠軍,2022/06/11 GLAD)",
          path: awardsPath_111[3],
        },
        {
          num: "25.",
          name: "2022 (第十屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽",
          student_name: "(選手:黃冠勳)",
          awards: "(中區賽 ICT 計算機綜合能力 獲得冠軍,2022/06/11 GLAD)",
          path: awardsPath_111[4],
        },
        {
          num: "26.",
          name: "111年度國立勤益科技大學電資學院學生實務專題製作競賽",
          student_name: "(選手:陳政廷)",
          awards:
            "(0xCommunity 一種基於非同值化代幣市場之會員社群交流平台 獲得入圍獎,2022/5/12 勤益科大)",
          path: awardsPath_111[11],
        },
        {
          num: "27.",
          name: "2022 ZERO HUNGER 黑客松：技職盃全國大賽",
          student_name: "(選手:黃泓喨、温秉勳、胡修瑞)",
          awards: "(中區分區賽獲得最佳簡報獎,2022/4/24 雲林科大)",
          path: awardsPath_111[5],
        },
        {
          num: "28.",
          name: "2022 ZERO HUNGER 黑客松：技職盃全國大賽",
          student_name: "(選手:黃士豪、陳政廷、黃冠勳)",
          awards: "(中區分區賽獲得佳作,2022/4/24 雲林科大)",
          path: awardsPath_111[6],
        },
        {
          num: "29.",
          name: "2022 ZERO HUNGER 黑客松：技職盃全國大賽",
          student_name: "(選手:藍詠弘、徐振傑、蔡雅琴)",
          awards: "(中區分區賽獲得入選,2022/4/24 雲林科大)",
          path: awardsPath_111[7],
        },
        {
          num: "30.",
          name: "2022 TIRC台灣智慧型機器人大賽",
          student_name: "(選手:胡修瑞、温秉勳)",
          awards:
            "(A1-U競速接力自走循跡車競賽(大專組) 獲得第一名,2022/03/05 勤益科大)",
          path: awardsPath_111[0],
        },
        {
          num: "30.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards:
            "(全國-全國賽專業AI_Literacy人工智慧類獲得亞軍,2022/3/5 GLAD/台師大/黎明技術學院)",
          path: awardsPath_110[0],
        },
        {
          num: "31.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:徐振傑)",
          awards:
            "(全國-全國賽ICT資訊類(計算機)季軍,2022/3/5 GLAD/台師大/黎明技術學院)",
          path: awardsPath_110[1],
        },
        {
          num: "32.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:鄭郁蓁)",
          awards:
            "(全國-全國賽ICT資訊類(計算機)季軍,2022/3/5 GLAD/台師大/黎明技術學院)",
          path: awardsPath_110[2],
        },
      ],
      //110年專題製作與競賽
      contest110: [
        {
          num: "1.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards:
            "(全國-中區區域賽專業人工智慧類獲得冠軍,2021/11/27 GLAD/台師大/建國科大)",
          path: awardsPath_110[3],
        },
        {
          num: "2.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:鄭郁蓁)",
          awards:
            "(全國-中區區域賽專業資訊類獲得冠軍,2021/11/27 GLAD/台師大/建國科大)",
          path: awardsPath_110[4],
        },
        {
          num: "3.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:徐振傑)",
          awards:
            "(全國-中區區域賽專業資訊類獲得亞軍,2021/11/27 GLAD/台師大/建國科大)",
          path: awardsPath_110[5],
        },
        {
          num: "4.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:藍詠弘)",
          awards:
            "(全國-中區區域賽專業資訊類獲得亞軍,2021/11/27 GLAD/台師大/建國科大)",
          path: awardsPath_110[6],
        },
        {
          num: "5.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃冠勳)",
          awards:
            "(全國-中區區域賽專業資訊類獲得季軍,2021/11/27 GLAD/台師大/建國科大)",
          path: awardsPath_110[7],
        },
        {
          num: "6.",
          name: "2021第十屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:陳政廷)",
          awards:
            "(全國-中區區域賽專業資訊類獲得季軍,2021/11/27 GLAD/台師大/建國科大)",
          path: awardsPath_110[8],
        },
        {
          num: "7.",
          name: "2021 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(人工智慧類-獲得冠軍,2021/12/01 GLAD/台師大/台中市政府)",
          path: awardsPath_110[9],
        },
        {
          num: "8.",
          name: "2021 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:徐振傑)",
          awards: "(資訊類-獲得季軍,2021/12/01 GLAD/台師大/台中市政府)",
          path: awardsPath_110[10],
        },
        {
          num: "9.",
          name: "2021 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:黃冠勳)",
          awards: "(人工智慧類-獲得金腦獎,2021/12/01 GLAD/台師大/台中市政府)",
          path: awardsPath_110[11],
        },
        {
          num: "10.",
          name: "2021 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:陳政廷 )",
          awards: "(資訊類 -獲得金腦獎,2021/12/01 GLAD/台師大/台中市政府)",
          path: awardsPath_110[12],
        },
        {
          num: "11.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 全國賽 Web Security網路安全",
          student_name: "(選手:陳冠翰)",
          awards: "(獲得冠軍,2021/07/26 GLAD)",
          path: awardsPath_110[13],
        },
        {
          num: "12.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 全國賽 Big Data Analysis大數據分析",
          student_name: "(選手:藍詠弘)",
          awards: "(獲得冠軍,2021/07/26 GLAD)",
          path: awardsPath_110[14],
        },
        {
          num: "13.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 全國賽 ICTP計算機程式語言設計能力",
          student_name: "(選手:黃泓喨)",
          awards: "(獲得亞軍,2021/07/26 GLAD)",
          path: awardsPath_110[15],
        },
        {
          num: "14.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 全國賽 Web Security網路安全",
          student_name: "(選手:黃士豪)",
          awards: "(獲得亞軍,2021/07/26 GLAD)",
          path: awardsPath_110[16],
        },
        {
          num: "15.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 全國賽 Network Technology網路技術",
          student_name: "(選手:黃士豪)",
          awards: "(獲得季軍,2021/07/26 GLAD)",
          path: awardsPath_110[17],
        },
        {
          num: "16. ",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 中區賽 CIW大數據分析師",
          student_name: "(選手:藍詠弘)",
          awards: "(獲得冠軍,2021/07/03 GLAD)",
          path: awardsPath_110[18],
        },
        {
          num: "17.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 中區賽 CIW網路安全工程師",
          student_name: "(選手:陳冠翰)",
          awards: "(獲得冠軍,2021/07/03 GLAD)",
          path: awardsPath_110[19],
        },
        {
          num: "18.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 中區賽 Network Technology網路技術",
          student_name: "(選手:黃士豪)",
          awards: "(獲得冠軍,2021/07/03 GLAD)",
          path: awardsPath_110[20],
        },
        {
          num: "19.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 中區賽 AIL人工智慧素養",
          student_name: "(選手:藍詠弘)",
          awards: "(獲得冠軍,2021/07/03 GLAD)",
          path: awardsPath_110[21],
        },
        {
          num: "20.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 中區賽 ICTP計算機程式語言設計能力",
          student_name: "(選手:黃泓喨)",
          awards: "(獲得冠軍,2021/07/03 GLAD)",
          path: awardsPath_110[22],
        },
        {
          num: "21.",
          name: "2021 計算機多媒體綜合能力與人工智慧素養及商務專業應用大賽 中區賽 ICT計算機綜合能力",
          student_name: "(選手:賴信儒)",
          awards: "(獲得冠軍,2021/07/03 GLAD)",
          path: awardsPath_110[23],
        },
        {
          num: "22.",
          name: "2021 ZERO HUNGER 黑客松：技職盃全國大賽 中區賽",
          student_name: "(選手:藍詠弘、胡修瑞、曹俊屏)",
          awards: "(獲得評審團大獎,2021/04/28 勤益科大)",
          path: awardsPath_110[24],
        },
        {
          num: "23.",
          name: "2021 ZERO HUNGER 黑客松：技職盃全國大賽 中區賽",
          student_name: "(選手:黃士豪、賴信儒、陳柏翰)",
          awards: "(獲得最佳人氣獎,2021/04/28 勤益科大)",
          path: awardsPath_110[25],
        },
        {
          num: "24.",
          name: "2020 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(獲得全國賽-亞軍,2021/01/26 台灣師大)",
          path: awardsPath_110[26],
        },
        {
          num: "25.",
          name: "2020 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:王昱傑)",
          awards: "(獲得全國賽ICT資訊(計算機)-季軍,2021/01/26 台灣師大)",
          path: awardsPath_110[27],
        },
        {
          num: "26.",
          name: "2020 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:陳冠翰)",
          awards: "(獲得全國賽-金腦獎,2021/01/26 台灣師大)",
          path: awardsPath_110[28],
        },
        {
          num: "27.",
          name: "教育部智慧創新跨域跨校專題研究成果聯合競賽",
          student_name: "(選手:藍詠弘、陳政廷、黃冠勳、徐振傑)",
          awards: "(門禁防疫監控系統 獲得潛力無限獎,2021/12/20 勤益科大)",
          path: awardsPath_110[29],
        },
      ],

      //109年專題製作與競賽
      contest109: [
        {
          num: "1.",
          name: "2020 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(資訊類-獲得冠軍,2020/12/06 GLAD/台師大/台中市政府)",
          path: "",
        },
        {
          num: "2.",
          name: "2020 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:陳冠翰)",
          awards: "(資訊類-獲得亞軍,2020/12/06 GLAD/台師大/台中市政府)",
          path: "",
        },
        {
          num: "3.",
          name: "2020 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:曹俊屏)",
          awards: "(資訊類-獲得季軍,2020/12/06 GLAD/台師大/台中市政府)",
          path: "",
        },
        {
          num: "4.",
          name: "2020 年臺中市菁英盃-專業英文聽寫與詞彙能力大賽",
          student_name: "(選手:王昱傑)",
          awards: "(資訊類-獲得金腦獎,2020/12/06 GLAD/台師大/台中市政府)",
          path: "",
        },
        {
          num: "5.",
          name: "2020第九屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards:
            "(全國-中區區域賽專業資訊類獲得冠軍,2020/11/14 GLAD/台師大/建國科大)",
          path: "",
        },
        {
          num: "6.",
          name: "2020第九屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:王昱傑)",
          awards:
            "(全國-中區區域賽專業資訊類獲得亞軍,2020/11/14 GLAD/台師大/建國科大)",
          path: "",
        },
        {
          num: "7.",
          name: "2020第九屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:陳冠翰)",
          awards:
            "(全國-中區區域賽專業資訊類獲得亞軍,2020/11/14 GLAD/台師大/建國科大)",
          path: "",
        },
        {
          num: "8.",
          name: "2020第九屆專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:黃士豪)",
          awards:
            "(全國-中區區域賽專業資訊類獲得季軍,2020/11/14 GLAD/台師大/建國科大)",
          path: "",
        },
        {
          num: "9.",
          name: "國立勤益科技大學資訊工程系108學年度實務專題競賽",
          student_name: "(選手:李長恩)",
          awards:
            "(題目:成為虛擬偶像的中之人與真人互動 獲得佳作,2020/07/28 勤益科大)",
          path: "",
        },
        {
          num: "10.",
          name: "國立勤益科技大學資訊工程系108學年度實務專題競賽",
          student_name: "(選手:劉楊富)",
          awards: "(題目:視覺化資安技術教學網 獲得佳作,2020/07/28 勤益科大)",
          path: "",
        },
        {
          num: "11.",
          name: "2020 ACM-ICPC (第五屆全國科技大專校院程式競賽)",
          student_name: "(選手:陳冠翰、王昱傑、廖止凡)",
          awards: "(獲得 銀獎 ,2020/07/08 虎尾科大)",
          path: "",
        },
        {
          num: "12.",
          name: "2020 ACM-ICPC (第五屆全國科技大專校院程式競賽)",
          student_name: "(選手:蔡乙民、劉楊富、黃泓喨)",
          awards: "(獲得 銀獎 ,2020/07/08 虎尾科大)",
          path: "",
        },
        {
          num: "13.",
          name: "2020華人資訊語文競技與設計大賞「2020 (第八屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽」全國賽",
          student_name: "(選手:洪琮閔)",
          awards:
            "(獲得獲得CIW 網路安全工程師(Web Security)項目全國總冠軍及分區冠軍,2020/07/04 台灣師大)",
          path: "",
        },
        {
          num: "14.",
          name: "2020華人資訊語文競技與設計大賞「2020 (第八屆)全國計算機多媒體綜合能力與人工智能素養及商務專業應用大賽」全國賽",
          student_name: "(選手:洪琮閔)",
          awards:
            "(獲得獲得CIW 網路技術工程師(Network Technology)項目全國總冠軍及分區冠軍,2020/07/04 台灣師大)",
          path: "",
        },
        {
          num: "15.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:朱只耘)",
          awards: "(獲得全國賽-季軍,2020/01/20 台灣師大)",
          path: "",
        },
        {
          num: "16.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:戴宥貞)",
          awards: "(獲得全國賽-季軍,2020/01/20 台灣師大)",
          path: "",
        },
        {
          num: "17.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:陳漢恩)",
          awards: "(獲得全國賽-金腦獎,2020/01/20 台灣師大)",
          path: "",
        },
      ],

      //108年專題製作與競賽
      contest108: [
        {
          num: "1.",
          name: "2019 愛寶盃iPOE創客機器人大賽",
          student_name: "(選手:謝宇彥，陳冠翰，朱只耘)",
          awards: "(獲得mBot輪型機器人大專院校組冠軍,2019/12/14 建國科大)",
          path: "",
        },
        {
          num: "2.",
          name: "2019 愛寶盃iPOE創客機器人大賽",
          student_name: "(選手:陳漢恩，黃泓喨，張晉銘)",
          awards: "(獲得mBot輪型機器人大專院校組佳作,2019/12/14 建國科大)",
          path: "",
        },
        {
          num: "3.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:陳漢恩)",
          awards: "(獲得中區賽-冠軍,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "4.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:劉楊富)",
          awards: "(獲得中區賽-亞軍,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "5.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:戴宥貞)",
          awards: "(獲得中區賽-亞軍,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "6.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:黃泓喨)",
          awards: "(獲得中區賽-季軍,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "7.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:陳冠翰)",
          awards: "(獲得中區賽-季軍,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "8.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:蔡乙民)",
          awards: "(獲得中區賽-季軍,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "9.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:黃峻翔)",
          awards: "(獲得中區賽-金腦獎,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "10.",
          name: "2019 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:謝宇彥)",
          awards: "(獲得中區賽-金腦獎,2019/11/23 建國科大)",
          path: "",
        },
        {
          num: "11.",
          name: "2019 第二屆臺中市專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:劉楊富)",
          awards:
            "(獲得大學一般生–專業英文詞彙組（資訊）-亞軍,108/12/24 豐原高商)",
          path: "",
        },
        {
          num: "12. ",
          name: "2019 第二屆臺中市專業英文詞彙與聽寫能力大賽",
          student_name: "(選手:陳漢恩)",
          awards:
            "(獲得大學一般生–專業英文詞彙組（資訊）-季軍,108/12/24 豐原高商)",
          path: "",
        },
        {
          num: "13. ",
          name: "108年國立勤益科技大學資訊工程系實務專題競賽",
          student_name: "(選手:林昶睿)",
          awards:
            "(獲得『3D Virtual partner』-第一名,2019/06/26 勤益科大)(獲得『3D Virtual partner』-最佳人氣獎,2019/06/26 勤益科大)",
          path: "",
        },
        {
          num: "14.",
          name: "108年國立勤益科技大學資訊工程系實務專題競賽",
          student_name: "(選手:周凱哲)",
          awards:
            "(獲得『基於FFT自製快速節奏點產生的演算法與虛擬節奏體感遊戲』-佳作,2019/06/26 勤益科大)",
          path: "",
        },
        {
          num: "15.",
          name: "108年國立勤益科技大學資訊工程系實務專題競賽",
          student_name: "(選手:許哲綸、林原醇)",
          awards:
            "(獲得『以Kinect為基礎之互動體驗園區』-佳作,2019/06/26 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得『以Kinect為基礎之互動體驗園區』-創意獎,2019/06/26 勤益科大)",
          path: "",
        },
        {
          num: "16.",
          name: "108年國立勤益科技大學電資學院院專題",
          student_name: "(選手:林昶睿)",
          awards:
            "(獲得大專組『Intelligent Butler』-第一名,2019/05/09 勤益科大)",
          path: "",
        },
        {
          num: "17.",
          name: "108年國立勤益科技大學電資學院院專題",
          student_name: "(選手:許哲綸、林原醇)",
          awards:
            "(獲得大專組『以Kinect為基礎之互動展示園區』-佳作,2019/05/09 勤益科大)",
          path: "",
        },
        {
          num: "18.",
          name: "2019 永續城鄉黑客松：技職盃中區賽",
          student_name: "(選手:陳漢恩、劉楊富、黃泓喨)",
          awards: "(獲得中區賽-最佳創造價值獎,2019/05/04 雲林科大)",
          path: "",
        },
        {
          num: "19.",
          name: "2019 永續城鄉黑客松：技職盃中區賽",
          student_name: "(選手:林家豪、許楹怡、陳暉凱)",
          awards: "(獲得中區賽-佳作,2019/05/04 雲林科大)",
          path: "",
        },
        {
          num: "20.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:林家豪)",
          awards:
            "(獲得DMT數位多媒體綜合能力Essentials核心能力組全國賽-特等獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得DMT數位多媒體綜合能力Essentials核心能力組中區賽-第一名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "21.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:林昌儒)",
          awards:
            "(獲得DMT數位多媒體綜合能力Essentials核心能力組全國賽-一等獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得DMT數位多媒體綜合能力Essentials核心能力組中區賽-第二名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "22.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:呂翔瑋)",
          awards:
            "(獲得ICT計算機綜合能力Essentials核心能力組中區賽-第一名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "23.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:劉東祐)",
          awards:
            "(獲得ICT計算機綜合能力Essentials核心能力組中區賽-第二名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "24.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:張奕葟)",
          awards:
            "(獲得ICT計算機綜合能力Essentials核心能力組中區賽-第三名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "25.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:陳泰明)",
          awards:
            "(獲得ICT計算機綜合能力Essentials核心能力組中區賽-金腦獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "26.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:黃峻翔)",
          awards:
            "(獲得BAP Presentations商業簡報Essentials核心能力組全國賽-二等獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得BAP Presentations商業簡報Essentials核心能力組中區賽-第一名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "27.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:陳宏嘉)",
          awards:
            "(獲得BAP Presentations商業簡報Essentials核心能力組全國賽-二等獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得BAP Presentations商業簡報Essentials核心能力組中區賽-第二名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得BAP Documents文書處理Essentials核心能力組中區賽-第三名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "28.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:莊鎮嘉)",
          awards:
            "(獲得BAP Presentations商業簡報Essentials核心能力組中區賽-第三名,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得BAP Documents文書處理Essentials核心能力組中區賽-金腦獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得BAP Spreadsheets電子試算表Essentials核心能力組中區賽-金腦獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "29.",
          name: "2019 全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:陳漢恩)",
          awards:
            "(獲得BAP Presentations商業簡報Essentials核心能力組中區賽-金腦獎,2019/03/30 勤益科大)",
          path: "",
        },
        {
          num: "30.",
          name: "2018 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:陳漢恩)",
          awards: "(獲得全國賽-入圍,2019/01/24 臺灣師大)",
          path: "",
        },
        {
          num: "31.",
          name: "2018 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:林昌儒)",
          awards: "(獲得全國賽-金腦獎,2019/01/24 臺灣師大)",
          path: "",
        },
      ],

      //107年專題製作與競賽
      contest107: [
        {
          num: "1.",
          name: "2018 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:劉楊富)",
          awards: "(獲得全國中區賽-冠軍,2018/11/25 建國科大)",
          path: "",
        },
        {
          num: "2.",
          name: "2018 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:陳漢恩)",
          awards: "(獲得全國中區賽-亞軍,2018/11/25 建國科大)",
          path: "",
        },
        {
          num: "3.",
          name: "2018 專業英(日)文詞彙與聽力能力大賽",
          student_name: "(選手:林昌儒)",
          awards: "(獲得全國中區賽-亞軍,2018/11/25 建國科大)",
          path: "",
        },
        {
          num: "4.",
          name: "2018 第一屆台中市英文菁英盃",
          student_name: "(選手:劉楊富)",
          awards: "(獲得專業英文詞彙資訊ICT組冠軍,2018/11/03 豐原高商)",
          path: "",
        },
        {
          num: "5.",
          name: "2018 第一屆台中市英文菁英盃",
          student_name: "(選手:林昶睿)",
          awards: "(獲得專業英文詞彙資訊ICT組亞軍,2018/11/03 豐原高商)",
          path: "",
        },
        {
          num: "6.",
          name: "2018 第一屆台中市英文菁英盃",
          student_name: "(選手:林昌儒)",
          awards: "(獲得專業英文詞彙資訊ICT組季軍,2018/11/03 豐原高商)",
          path: "",
        },
        {
          num: "7.",
          name: "2018 第一屆台中市英文菁英盃",
          student_name: "(選手:陳暉凱)",
          awards: "(獲得專業英文詞彙資訊ICT組金腦獎,2018/11/03 豐原高商)",
          path: "",
        },
        {
          num: "8.",
          name: "2018 第四屆愛寶盃iPOE創客機器人大賽",
          student_name: "(選手:謝宇彥、陳暉凱、林昶睿)",
          awards: "(獲得mBot輪型機器人大專院校組冠軍,2018/11/10 建國科大)",
          path: "",
        },
        {
          num: "9.",
          name: "2018 第四屆愛寶盃iPOE創客機器人大賽",
          student_name: "(選手:林家豪、林昌儒)",
          awards: "(獲得Ranger遊俠機器人大專院校組冠軍,2018/11/10 建國科大)",
          path: "",
        },
        {
          num: "10.",
          name: "2018 TIRT全能機器人國際邀請賽",
          student_name: "(選手:謝宇彥、陳暉凱、林昶睿、林昌儒)",
          awards:
            "(獲得金屬積木自走車接力賽大專社會組第二名,2018/10/20 桃園巨蛋)",
          path: "",
        },
        {
          num: "11.",
          name: "106學年度教育部資訊志工團體獎",
          student_name: "(106002 iNEMU)",
          awards: "(獲得服務執行獎銅獎, 臺教資(三)字第1070112257號)",
          path: "",
        },
        {
          num: "12.",
          name: "「2018第八屆大學生計算機應用能力與專業英文暨海峽兩岸專業核心技能素養大賽」海峽兩岸賽(北京賽)",
          student_name: "(選手:林昌儒)",
          awards: "(獲得網路專業技術大學本科組-冠軍,2018/05/26)",
          path: "",
        },
        {
          num: "13.",
          name: "「2018全國計算機與多媒體綜合能力及商務專業應用大賽」全國賽",
          student_name: "(選手:林昌儒)",
          awards: "(獲得網路專業技術組特等獎,2018/03/17)",
          path: "",
        },
        {
          num: "14.",
          name: "「華人資訊語文競技與創意設計大賞─2017專業英(日)文詞彙與聽力能力大賽」全國總決賽",
          student_name: "(選手:童宇宏)",
          awards: "(獲得全國賽第二名,2018/01/29)",
          path: "",
        },
        {
          num: "15.",
          name: "「華人資訊語文競技與創意設計大賞─2017專業英(日)文詞彙與聽力能力大賽」全國總決賽",
          student_name: "(選手:林昶睿)",
          awards: "(獲得全國賽金腦獎,2018/01/29)",
          path: "",
        },
        {
          num: "16.",
          name: "「華人資訊語文競技與創意設計大賞─2017專業英(日)文詞彙與聽力能力大賽」全國總決賽",
          student_name: "(選手:蔡乙民)",
          awards: "(獲得全國賽入圍,2018/01/29)",
          path: "",
        },
      ],

      //106年專題製作與競賽
      contest106: [
        {
          num: "1.",
          name: "「華人資訊語文競技與創意設計大賞─2017專業英(日)文詞彙與聽力能力大賽」",
          student_name: "(選手:童宇宏)",
          awards: "(獲得全國賽-中區-第一名,2017/12/16)",
          path: "",
        },
        {
          num: "2.",
          name: "「華人資訊語文競技與創意設計大賞─2017專業英(日)文詞彙與聽力能力大賽」",
          student_name: "(選手:林昶睿)",
          awards: "(獲得全國賽-中區-第二名,2017/12/16)",
          path: "",
        },
        {
          num: "3.",
          name: "「華人資訊語文競技與創意設計大賞─2017專業英(日)文詞彙與聽力能力大賽」",
          student_name: "(選手:蔡乙民)",
          awards: "(獲得全國賽-中區-第二名,2017/12/16)",
          path: "",
        },
        {
          num: "4.",
          name: "105學年度教育部傑出資訊志工團隊選拔",
          student_name: "(105004 iNEMU)",
          awards:
            "(獲得傑出團隊金質獎, 2017/12/10頒獎, 臺教資(三)字第1060090969號)",
          path: "",
        },
        {
          num: "5.",
          name: "105學年度教育部資訊志工數位關懷大賽",
          student_name: "(105004 iNEMU) ",
          awards: "(獲得優勝, 2017/12/10頒獎, 臺教資(三)字第1060090969號)",
          path: "",
        },
        {
          num: "6.",
          name: "The 2017 ACM-ICPC Asia Taiwan National Programming Contest for Technology Universities. 第二屆全國大專科技校院程式競賽!",
          student_name: "(選手:郭冠宏、梁楚璿、葉宗翰)",
          awards: "(獲得第二屆全國大專科技校院程式競賽-第三名,2017/06/28)",
          path: "",
        },
        {
          num: "7.",
          name: "The 2017 ACM-ICPC Asia Taiwan National Programming Contest for Technology Universities. 第二屆全國大專科技校院程式競賽! ",
          student_name: "(選手:洪皓庭、林觀明、傅柏軒)",
          awards:
            "(獲得第二屆全國大專科技校院程式競賽-最佳評審獎(Judges’ Award),2017/06/28)",
          path: "",
        },
        {
          num: "8.",
          name: "「天氣亂入輕旅行」",
          student_name: "(選手:吳東霖)",
          awards:
            "(獲得國立勤益科技大學電資學院院專題大學部-第一名,2017/05/08)",
          path: "",
        },
        {
          num: "9.",
          name: "「2017智慧生活黑客松：技職盃全國大賽」南區賽",
          student_name: "(選手:郭冠宏、林家豪、林昌儒)",
          awards: "(獲得南區賽佳作及入圍總決賽,2017/05/07)",
          path: "",
        },
        {
          num: "10.",
          name: "「2017智慧生活黑客松：技職盃全國大賽」南區賽",
          student_name: "(選手:蕭瑞余、許谷銓)",
          awards: "(獲得入圍總決賽,2017/05/07)",
          path: "",
        },
        {
          num: "11.",
          name: "「2017智慧生活黑客松：技職盃全國大賽」南區賽",
          student_name: "(選手:洪善淳、劉哲豪)",
          awards: "(獲得入圍總決賽,2017/05/07)",
          path: "",
        },
        {
          num: "12.",
          name: "「2017智慧生活黑客松：技職盃全國大賽」南區賽",
          student_name: "(選手:吳東霖)",
          awards: "(獲得入圍總決賽,2017/05/07)",
          path: "",
        },
        {
          num: "13.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:吳東霖)",
          awards: "(獲得CIW-網路安全工程師-全國賽特等獎,2017/03/25)",
          path: "",
        },
        {
          num: "14.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:許谷銓)",
          awards: "(獲得電子試算表Essentials組-全國賽三等獎,2017/03/25)",
          path: "",
        },
        {
          num: "15.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:許谷銓)",
          awards: "(獲得商業簡報Essentials組-全國賽三等獎,2017/03/25)",
          path: "",
        },
        {
          num: "16.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:吳東霖)",
          awards: "(獲得商業簡報Essentials組-全國賽三等獎,2017/03/25)",
          path: "",
        },
        {
          num: "17.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:洪善淳)",
          awards: "(獲得文書處理Essentials組-全國區賽金腦獎,2017/03/25)",
          path: "",
        },
        {
          num: "18.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:許谷銓)",
          awards: "(獲得電子試算表Essentials組-全國區賽第一名,2017/03/25)",
          path: "",
        },
        {
          num: "19.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:許谷銓)",
          awards: "(獲得商業簡報Essentials組-全國區賽第一名,2017/03/25)",
          path: "",
        },
        {
          num: "20.",
          name: "2017全國計算機與多媒體綜合能力及商務專業應用大賽",
          student_name: "(選手:吳東霖)",
          awards: "(獲得商業簡報Essentials組-全國區賽第二名,2017/03/25)",
          path: "",
        },
        {
          num: "21.",
          name: "華人資訊語文競技與創意設計大賽-專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:劉哲豪)",
          awards: "(獲得全國總決賽亞軍,2017/01/23)",
          path: "",
        },
        {
          num: "22.",
          name: "華人資訊語文競技與創意設計大賽-專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:施諭廷)",
          awards: "(獲得全國總決賽季軍,2017/01/23)",
          path: "",
        },
        {
          num: "23.",
          name: "華人資訊語文競技與創意設計大賽-專業英日文詞彙與聽力能力大賽",
          student_name: "(選手:吳東霖)",
          awards: "(獲得全國總決賽季軍,2017/01/23)",
          path: "",
        },
      ],

      //105年專題製作與競賽
      contest105: [
        {
          num: "1.",
          name: "FY16 GCP MCP Competition 微軟認證專家競賽!",
          student_name: "(選手:林昌儒)",
          awards:
            "(獲得Great China Regional Area. MCSD: Web Applistudent_nametions Champion-大中華冠軍,2016/08/19)",
          path: "",
        },
        {
          num: "2.",
          name: "第一屆全國大專科技校院程式競賽!",
          student_name: "(選手:郭冠宏、高昌廷、梁楚璿)",
          awards: "(獲得第一屆全國大專科技校院程式競賽-第二名,2016/06/24)",
        },
        {
          num: "3.",
          name: "教育部發展典範科技大學計畫2016全國技專校院黑客松大賽!雲燈輪輪轉、厝厝風火情",
          student_name: "(選手:林昌儒、郭冠宏、林家豪、洪善淳、許谷銓)",
          awards: "(獲得雲科大主辦全國大賽-佳作,2016/06/22-23)",
          path: "",
        },
        {
          num: "4.",
          name: "計算機綜合能力 ICT!",
          student_name: "(選手:吳東霖)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第一名,2016/03/25)",
          path: "",
        },
        {
          num: "5.",
          name: "計算機綜合能力 ICT!",
          student_name: "(選手:施諭廷)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第二名,2016/03/25)",
          path: "",
        },
        {
          num: "6.",
          name: "電子試算表 BAP!",
          student_name: "(選手:王曾柏)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第一名,2016/03/25)",
          path: "",
        },
        {
          num: "7.",
          name: "電子試算表 BAP!",
          student_name: "(選手:施諭廷)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第二名,2016/03/25)",
          path: "",
        },
        {
          num: "8.",
          name: "商業簡報 BAP!",
          student_name: "(選手:洪善淳)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第一名,2016/03/25)",
          path: "",
        },
        {
          num: "9.",
          name: "商業簡報 BAP!",
          student_name: "(選手:施諭廷)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第二名,2016/03/25)",
          path: "",
        },
        {
          num: "10.",
          name: "商業簡報 BAP!",
          student_name: "(選手:林家豪)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第三名,2016/03/25)",
          path: "",
        },
        {
          num: "11.",
          name: "文書處理 BAP!",
          student_name: "(選手:許谷銓)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第二名,2016/03/25)",
          path: "",
        },
        {
          num: "12.",
          name: "文書處理 BAP!",
          student_name: "(選手:洪善淳)",
          awards:
            "(獲得2016全國計算機綜合能力及商務專業應用大賽區賽-第三名,2016/03/25)",
          path: "",
        },
        {
          num: "13.",
          name: "基於行動裝置之大地活動定向測驗! ",
          student_name: "(選手:郭冠宏)",
          awards:
            "(獲得全國崧騰盃遊戲與遊戲機創意設計比賽-行動平台遊戲組-入圍,2016/02/01)",
          path: "",
        },
        {
          num: "14.",
          name: "邊緣人的撲克!",
          student_name: "(選手:施諭廷 吳東霖許谷銓)",
          awards:
            "(獲得全國崧騰盃遊戲與遊戲機創意設計比賽-行動平台遊戲組-入圍,2016/02/01)",
          path: "",
        },
        {
          num: "15.",
          name: "舞動的車子!",
          student_name: "(選手:洪善淳 林昌儒 林家豪)",
          awards:
            "(獲得2016年全國崧騰盃遊戲與遊戲機創意設計比賽-遊戲機組-入圍,2016/02/01)",
          path: "",
        },
        {
          num: "16.",
          name: "推箱子! ",
          student_name: "(選手:王曾柏 林昌儒 林家豪)",
          awards:
            "(獲得2016年全國崧騰盃遊戲與遊戲機創意設計比賽-遊戲機組-入圍,2016/02/01)",
          path: "",
        },
      ],

      //104年專題製作
      contest104: [
        {
          num: "1.",
          name: "P1智慧積木機器人!",
          student_name: "(選手:王曾柏 方宇嘉 吳東霖)",
          awards:
            "(獲得2015年愛寶盃智慧機器人全國賽總決賽-P1智慧排障組第二名,2015/11/28)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得2015年愛寶盃智慧機器人全國賽中苗賽區-P1智慧排障組第一名,2015/10/31)",
          path: "",
        },
        {
          num: "2.",
          name: "A1智慧輪型機器人!",
          student_name: "(選手:王曾柏 方宇嘉 吳東霖)",
          awards:
            "(獲得2015年愛寶盃智慧機器人全國賽中苗賽區-A1智慧迷宮組第一名,2015/10/31)",
          path: "",
        },
        {
          num: "3.",
          name: "P1智慧積木機器人! ",
          student_name: "(選手:王曾柏 方宇嘉 吳東霖)",
          awards:
            "(獲得2015年愛寶盃智慧機器人全國賽中苗賽區-P1智慧競速組第一名,2015/10/31)",
          path: "",
        },
        {
          num: "4.",
          name: "A1智慧輪型機器人!",
          student_name: "(選手:王曾柏 方宇嘉 吳東霖)",
          awards:
            "(獲得2015年愛寶盃智慧機器人全國賽中苗賽區-A1智慧競速組第二名,2015/10/31)",
          path: "",
        },
        {
          num: "5.",
          name: "需求導向路徑繞境設計-因應巨量數據關聯需求為基礎! ",
          student_name: "(組長:施諭廷)",
          awards:
            "(獲得104年國立勤益科大電資學院專題製作競賽研究所組-創意獎,2015/04/30)",
          path: "",
        },
        {
          num: "6.",
          name: "音樂有我!",
          student_name: "(組員:林園龍 施諭廷 方宇嘉 黃瓊賢)",
          awards:
            "(獲得104年國立勤益科大電資學院專題製作競賽大學組-創意獎,2015/04/30)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得第六屆全國孕龍盃、崧騰盃遊戲與遊戲機創意設計比賽-行動平台遊戲組-創意獎(勤益科大電資字第1040418043號),2015/04/18,入圍,2014/12/31)",
          path: "",
        },
        {
          num: "7.",
          name: "轟炸客的逆襲!(Honor Bomber!)",
          student_name: "(組員:方宇嘉 黃瓊賢 張家豪)",
          awards:
            "(獲得104年國立勤益科大電資學院專題製作競賽大學組-創意獎,2015/04/30)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得第六屆全國孕龍盃、崧騰盃遊戲與遊戲機創意設計比賽-一般遊戲組-創意獎(勤益科大電資字第1040418075號,2015/04/18,入圍,2014/12/31)",
          path: "",
        },
        {
          num: "8.",
          name: "猜拳遊戲機! ",
          student_name: "(組員:王曾柏 楊于萱)",
          awards:
            "(獲得第六屆全國孕龍盃、崧騰盃遊戲與遊戲機創意設計比賽-一般遊戲組-創意獎(勤益科大電資字第1040418078號,2015/04/18,入圍,2014/12/31)",
          path: "",
        },
        {
          num: "9.",
          name: "資訊專業英文詞彙與電子試算表應用!",
          student_name: "(組長:施諭廷)",
          awards:
            "(獲得「2015兩岸專業英文詞彙能力及商務專業應用能力大賽」-海峽兩岸賽總決賽-計算機類ICT英文詞彙與電子試算表應用項目-雙核心能力組-金腦獎,格萊得獎字第15TWSCT00096號,2015/07/08)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得「2015兩岸專業英文詞彙能力及商務專業應用能力大賽」-海峽兩岸賽總決賽-ICT計算機項目-專業英文詞彙能力組-金腦獎,格萊得獎字第15TWSCT00095號,2015/07/08)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得「2015兩岸專業英文詞彙能力及商務專業應用能力大賽」-海峽兩岸賽總決賽-電子試算表應用項目-商務專業應用能力組-金腦獎,格萊得獎字第15TWSCT00094號,2015/07/08)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得「2015兩岸專業英文詞彙能力及商務專業應用能力大賽」-海峽兩岸賽臺灣區賽-計算機類ICT英文詞彙與電子試算表應用項目-雙核心能力組-金腦獎,格萊得獎字第15TWSCT00027號,2015/06/01)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得「2015兩岸專業英文詞彙能力及商務專業應用能力大賽」-海峽兩岸賽臺灣區賽-ICT計算機項目-專業英文詞彙能力組-金腦獎,格萊得獎字第15TWSCT00026號,2015/06/01)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得「2015兩岸專業英文詞彙能力及商務專業應用能力大賽」-海峽兩岸賽臺灣區賽-電子試算表應用項目-商務專業應用能力組-金腦獎,格萊得獎字第15TWSCT00094號,2015/07/08)",
          path: "",
        },
        {
          num: "10.",
          name: "資訊專業英文!",
          student_name: "(組長:施諭廷)",
          awards:
            "(獲得專業英文詞彙能力大賽PVQC-全國賽-資訊組-金腦獎, 2015/02/11)(獲得2014專業英文詞彙能力大賽PVQC-中區區賽-資訊組-第二名, 2014/11/06)",
          path: "",
        },
        {
          num: "11.",
          name: "資訊專業英文! ",
          student_name: "(組長:張家豪)",
          awards:
            "(獲得專業英文詞彙能力大賽PVQC-全國賽-資訊組-金腦獎, 2015/02/11)(獲得2014專業英文詞彙能力大賽PVQC-中區區賽-資訊組-第三名, 2014/11/06)",
          path: "",
        },
      ],

      //103年專題製作
      contest103: [
        {
          num: "1.",
          name: "賽格機器人! ",
          student_name:
            "(選手:陳文敬 黃守仁 蔡清祥 陳冠豪 (與邱俊智老師共同指導))",
          awards:
            "(獲得2014亞洲機器人運動競技大賽-D09 機器人創意競賽-第二名, 2014/12/20)",
          path: "",
        },
        {
          num: "2.",
          name: "都市叢林打野砲戰! ",
          student_name:
            "(選手:方宇嘉 黃守仁 蔡清祥 劉仁智 (與邱俊智老師共同指導))",
          awards:
            "(獲得2014亞洲機器人運動競技大賽-D09 機器人創意競賽-第五名, 2014/12/20)",
          path: "",
        },
        {
          num: "3.",
          name: "破塔遊戲-再蓋呀!",
          student_name: "(組長: 陳奕兆)",
          awards:
            "(獲得103年國立勤益科技大學資訊工程系實務專題競賽APP組-第三名, 2014/06/24) ",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得第五屆全國好馬盃遊戲與遊戲機創意設計比賽-行動平台遊戲組-最佳創意獎, 2014/04/17)",
          path: "",
        },
        {
          num: "4.",
          name: "射擊遊戲 – 森林小子! ",
          student_name: "(組長: 楊凱傑)",
          awards:
            "(獲得第五屆全國好馬盃遊戲與遊戲機創意設計比賽-行動平台遊戲組-最佳創意獎, 2014/04/17)",
          path: "",
        },
        {
          num: "5.",
          name: "神轉城堡遊戲",
          student_name: "(組長: 王其能)",
          awards:
            "(獲得第五屆全國好馬盃遊戲與遊戲機創意設計比賽-行動平台遊戲組-最佳創意獎, 2014/04/17)",
          path: "",
        },
        {
          num: "6.",
          name: "迷宮遊戲",
          student_name: "(組長: 徐達仁)",
          awards:
            "(獲得第五屆全國好馬盃遊戲與遊戲機創意設計比賽-一般遊戲組-入圍,2014/01/04)",
          path: "",
        },
        {
          num: "7.",
          name: "炸彈超人遊戲",
          student_name: "(組長: 劉浩帆)",
          awards:
            "(獲得第五屆全國好馬盃遊戲與遊戲機創意設計比賽-一般遊戲組-入圍,2014/01/04)",
          path: "",
        },
      ],

      //102年專題製作
      contest102: [
        {
          num: "1.",
          name: "聽障人士聽學助理",
          student_name: "(組長: 吳駿平)",
          awards: "",
        },
        {
          num: "2.",
          name: "手機遊戲 – God Finger",
          student_name: "(組長: 施諭廷)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "3.",
          name: "手機遊戲 – 象棋麻將",
          student_name: "(組長: 林伸弦)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "4.",
          name: "手機遊戲 – 野豬獵人(2013版) ",
          student_name: "(組長:莊侑錡、組員:施諭廷)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "5.",
          name: "手機遊戲 – student_nametch & Esstudent_nameper",
          student_name: "(組長: 林琮皓)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "6.",
          name: "手機遊戲 – N筆畫之小心蟲蟲",
          student_name: "(組長: 林家鴻)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "7.",
          name: "手機遊戲 – Ball Maze",
          student_name: "(組長: 張翔承)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "8.",
          name: "手機遊戲 – 音樂魔手",
          student_name: "(組長: 林逸軒)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "9.",
          name: "Unity手機遊戲 – Super War",
          student_name: "(組長: 賴柏豪、組員:吳駿平)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "10.",
          name: "手機遊戲 – 音樂遊戲",
          student_name: "(組長: 劉育誠)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "11.",
          name: "手機遊戲 – Table Hockey",
          student_name: "(組長: 游舜清)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組最佳創意獎,2013/04/23)",
          path: "",
        },
        {
          num: "12.",
          name: "手機遊戲 – Drip",
          student_name: "(組長: 陳威宇)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽行動平台遊戲組入圍獎,2013/01/01)",
          path: "",
        },
        {
          num: "13.",
          name: "手機遊戲 – Ball Decrypt",
          student_name: "(組長: 吳少宇)",
          awards:
            "(獲得2013第三屆全國鈊象盃遊戲與遊戲機創意設計比賽一般遊戲組入圍獎,2013/01/01)",
          path: "",
        },
        {
          num: "14.",
          name: "手機遊戲 – Pirate",
          student_name: "(組長: 陳映達)",
          awards: "",
          path: "",
        },
        {
          num: "15.",
          name: "2013國立勤益科技大學資訊盃軟體競賽",
          student_name: "(組長: 吳駿平) ",
          awards: "(獲得第三名, 2013/5/15)",
          path: "",
        },
      ],

      //101年專題製作
      contest101: [
        {
          num: "1.",
          name: "手機遊戲 – God Finger ",
          student_name: "(組長: 施諭廷)",
          awards:
            "(獲得2012中國學院獎組織委員會、北京工業大學聯合主辦的“中國學院獎”第二屆遊戲設計大賽–移動遊戲類優秀獎(共有兩岸34所院校的1020件作品,共六類僅52件作品獲獎),2012/11/16)",
        },
        {
          num: "2.",
          name: "手機遊戲 – 野豬獵人(2012版)",
          student_name: "(組長:陳威宇、組員: 莊侑錡、吳駿平、林伸旋、張翔承)",
          awards: "(獲得2012電資學院學生實務專題製作競賽—佳作,2012/03/30)",
        },
        {
          num: "3.",
          name: "手機APP – 電子地圖顯示系統",
          student_name: "(組長: 莊侑錡、組員:林伸弦、陳威宇)",
          awards: "(獲得2012全國大專院校行動遊戲應用APP設計競賽入圍獎)",
        },
        {
          num: "4.",
          name: "手機遊戲 – 象棋麻將",
          student_name: "(組長: 林伸弦)",
          awards: "(獲得2012全國大專院校行動遊戲應用APP設計競賽入圍獎)",
        },
        {
          num: "5.",
          name: "手機遊戲 – 金庫密碼",
          student_name: "(組長: 莊侑錡、組員:陳威宇)",
          awards: "",
        },
        {
          num: "6.",
          name: "第二屆計算機基礎應用能力大賽(IC3) ",
          student_name: "(組長: 施諭廷)",
          awards:
            "(獲得計算機組競賽國內賽一等獎)(獲得計算機組全國最高分,滿分,2012/04/15)",
        },
      ],

      //100年專題製作
      contest100: [
        {
          num: "1.",
          name: "野豬獵人(ShiVa 3D)",
          student_name: "(組長:吳恒緯、組員: 林廷諭、吳駿平)",
          awards: "(獲得2011大中華VR盟主大賽—手機遊戲設計組—佳作,2011/06/29)",
          path: "",
        },
        {
          num: "2.",
          name: "智慧型觸控展示系統(Virtools)",
          student_name: "(組長:吳恒緯、組員: 張翔承、黃文輝)",
          awards: "(獲得2011大中華VR盟主大賽—多元應用組—佳作,2011/06/29)",
          path: "",
        },
        {
          num: "3.",
          name: "RFID多重門禁監控管理系統",
          student_name: "(組長: 吳恒緯、組員: 許有鈞、江宗岳、林建宏)",
          awards:
            "(獲得第五屆凌陽盃系統晶片創意應用設計大賽指定主題組入選,(2011/04/29)",
          path: "",
        },
        {
          num: "4.",
          name: "即時行車影像記錄動點查詢系統",
          student_name: "(組長: 許有鈞、組員: 林建宏、吳恒緯、江宗岳)",
          awards:
            "(獲得第五屆凌陽盃系統晶片創意應用設計大賽指定主題組入圍,2011/04/29)",
          path: "",
        },
        {
          num: "5.",
          name: "即時定位派送簽收系統",
          student_name: "(組長: 江宗岳、組員: 林建宏、吳恒緯、許有鈞)",
          awards:
            "(獲得第五屆凌陽盃系統晶片創意應用設計大賽指定主題組入圍,2011/04/29)",
          path: "",
        },
        {
          num: "6.",
          name: "RFID智慧廁所應用",
          student_name: "(組長: 江宗岳、組員: 林建宏、許有鈞、劉家榮)",
          awards: "(獲得RFID多媒體創意競賽入圍,2010/12/03)",
          path: "",
        },
        {
          num: "7.",
          name: "計算機基礎應用能力大賽(IC3)",
          student_name: "(組長: 吳恒緯)",
          awards:
            "(獲得計算機組全球競賽海峽兩岸賽第一名)(獲得計算機組全國最高分,滿分,2011/5/9)(獲得計算機組中區賽第一名,2011/5/9)",
          path: "",
        },
        {
          num: "8.",
          name: "計算機基礎應用能力大賽(IC3)",
          student_name: "(組長: 吳駿平)",
          awards: "(獲得網路組中區賽第一名, 2011/5/9)",
          path: "",
        },
        {
          num: "9.",
          name: "第三屆資訊盃軟體競賽—數碼高手",
          student_name: "(組長: 吳駿平、組員:劉淑月、林賢柏)",
          awards: "(獲得全校第一名, 2011/6/10)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "(組長: 林冠名、組員:許國乾、賴楷岳)",
          awards: "(獲得全校佳作, 2011/6/10)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "(組長: 蘇梵彥、組員:林佑霖、蔡燦宇)",
          awards: "(獲得全校佳作, 2011/6/10)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "(組長: 賴柏豪、組員:穆承暘、夏志雄)",
          awards: "(獲得全校佳作, 2011/6/10)",
          path: "",
        },
      ],

      //98,99年專題製作
      contest9899: [
        {
          num: "1.",
          name: "以凌陽板實作公車動點查詢語音互動導引服務系統。",
          student_name:
            "(組長:劉宏偉、組員: 吳恒緯、林建宏、許有鈞、江宗岳、徐子恩)",
          awards:
            "(獲得第四屆凌陽盃系統晶片創意應用設計大賽指定主題組優獎(特優從缺),2010/05/07)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards: "(獲得2010資通訊創意競賽佳作,2010/10/20)",
          path: "",
        },
        {
          num: "2.",
          name: "智慧型數位快遞簽收系統。",
          student_name: "(組長:劉宏偉、組員:林宗緯)",
          awards:
            "(獲得第四屆凌陽盃系統晶片創意應用設計大賽通訊應用組入圍,2010/05/07)",
          path: "",
        },
        {
          num: "3.",
          name: "GPS簡訊即時行動定位地址地圖顯示系統。",
          student_name: "(組長:劉宏偉、組員:廖偉善)",
          awards:
            "(獲得國立勤益科大資工系第二屆專題競賽佳作(第四名),2009/06/30)",
          path: "",
        },
        {
          num: "4.",
          name: "混合式生物特徵無線射頻遙控辨識門鎖。",
          student_name: "(組長:劉宏偉、組員:吳恒緯、林宗緯、林廷諭)",
          awards: "(獲得2009全國RFID 創意設計競賽佳作,2009/09/28)",
          path: "",
        },
        {
          num: "5.",
          name: "3D視覺互動式圖形化密碼驗證系統。",
          student_name: "(組長:徐子恩 組員:楊富中)",
          awards: "(獲得國立勤益科大資工系第三屆專題競賽佳作,2010/06/28)",
          path: "",
        },
        {
          num: "6.",
          name: "實體感測角色扮演模擬系統-Webstudent_namem網路對戰遊戲。",
          student_name: "(組長:林宗緯 組員:林廷諭)",
          awards: "",
          path: "",
        },
      ],

      //97年專題製作
      contest97: [
        {
          num: "1.",
          name: "多層次無線傳輸聲控系統。",
          student_name: "(組長:何奇紘、組員:洪向澤、徐子恩)",
          awards:
            "(獲得國立勤益科大資工系第一屆專題競賽電腦與網路應用組第二名,2009/1/20)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得國立勤益科大電資學院98年院專題競賽大學組第二名,2009/03/26)",
          path: "",
        },
        {
          num: "2.",
          name: "結合Zigbee、RFID、指紋辨識之無線無鑰匙孔門禁系統。",
          student_name: "(組長:林育如、組員:陳祐慈、張雅芃)",
          awards:
            "(獲得國立勤益科大資工系第一屆專題競賽電腦與網路應用組第三名,2009/01/20)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得國立勤益科大電資學院98年院專題競賽大學組佳作,2009/03/26)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards: "(獲得中央通訊社等多家媒體報導)",
          path: "",
        },
        {
          num: "3.",
          name: "5DT無線操控互動式立體虛擬實境-Dancing girls。",
          student_name: "(組長:吳恒緯、組員:林姿君、施家揚、劉信緯)",
          awards:
            "(獲得2008大中華VR盟主選拔賽台灣區大賽Virtools多元應用組佳作,2008/06/07)",
          path: "",
        },
        {
          num: "4.",
          name: "EMU無線快遞數位助理。",
          student_name: "(組長:鍾翰、組員:廖健勝、藍冠傑)",
          awards:
            "(獲得第二屆凌陽盃全國性系統晶片創意應用設計大賽通訊應用組入選,2008/05/09)",
          path: "",
        },
        {
          num: "",
          name: "",
          student_name: "",
          awards:
            "(獲得國立勤益科大資工系第一屆專題競賽晶片與多媒體組第三名,2009/01/20)",
          path: "",
        },
        {
          num: "5.",
          name: "虛擬實境—兒時的回憶之虛擬立體彈珠台。",
          student_name: "(組長:吳恒緯、組員:劉信緯、徐子恩、楊富中、王聖元)",
          awards:
            "(獲得2008大中華VR盟主選拔賽台灣區大賽Virtools多元應用組佳作,2008/06/07)",
          path: "",
        },
        {
          num: "6.",
          name: "以無線網路建構數位農場。",
          student_name: "(組長:劉崇志、組員:陳國志) (林灶生教授指導)",
          awards:
            "(獲得第二屆凌陽盃全國性系統晶片創意應用設計大賽通訊應用組第三名,2008/05/09)",
          path: "",
        },
        {
          num: "7.",
          name: "動態即時家庭環境監控網路–使用ZigBee網路。",
          student_name: "(組長:賴彥宏、組員:林宗緯)",
          awards: "(獲得國立勤益科大電子系97年專題競賽佳作,2008/11/29)",
          path: "",
        },
        {
          num: "8.",
          name: "聖誕燈樹—樹立水影。",
          student_name: "(組長:賴彥宏、組員:劉宏偉、徐子恩、楊富中、曹雅婷)",
          awards:
            "(獲得國立勤益科大2008第二屆聖誕樹(燈)創意設計比賽最佳創意獎,2008/12/20)",
          path: "",
        },
        {
          num: "9.",
          name: "聖誕燈樹—獨樹一格。",
          student_name: "(組長:賴彥宏、組員:黃信衡、吳恆緯、林宗緯、曹雅婷)",
          awards:
            "(獲得國立勤益科大2008第二屆聖誕樹(燈)創意設計比賽最佳設計獎,2008/12/20)",
          path: "",
        },
        {
          num: "10.",
          name: "互動式教學網頁設計。",
          student_name: "(組長:于良全、組員:賴嘉偉)",
          awards: "",
          path: "",
        },
      ],
      //95、96年專題製作
      contest9596: [
        {
          num: "1.",
          name: "E-Hub中小型連鎖企業之智慧型電子商務整合平台暨資訊安全整合設計。",
          student_name: "(組長:陳婉茹、組員:林律妏、林奕君、周育萱、王靜蓉)",
          awards: "(「2007全國技專院校觀光休憩物流資訊技術應用競賽」優勝)",
          path: "",
        },
        {
          num: "2.",
          name: "RFID無線射頻辨識技術於差勤系統建置及差勤防弊之綜合研究設計。",
          student_name: "(組長:戴宏安、組員:范崑達、景值威、莊凱傑、尹嘉偉)",
          awards: "(96年醒吾實務專題競賽資訊與傳播類組佳作)",
          path: "",
        },
        {
          num: "3.",
          name: "無線元件於智慧型溫泉空間之應用。",
          student_name: "(組長:陳思晴、組員:李倩、莊凡儀、劉倩妏、李筱瑩)",
          awards: "(「2008全國技專院校觀光休憩物流資訊技術應用競賽」優勝)",
          path: "",
        },
        {
          num: "4.",
          name: "多媒體數位內容之互動式理財網。",
          student_name: "",
          awards: "(96年全國性專題競賽佳作)",
          path: "",
        },
        {
          num: "5.",
          name: "中小型連鎖企業之智慧型電子商務整合平台暨資訊安全整合設計。",
          student_name: "(組長:羅大任、組員:林家葦、魏伊佩、黃信衡)",
          awards: "",
          path: "",
        },
        {
          num: "6.",
          name: "數位學習之數位內容應用於IPTV與student_nameTV同步協同整合運用設計。",
          student_name: "(組長:葉鎮豪、組員:徐啟豪、王崑達、陳冠汶、潘韋廷)",
          awards: "",
          path: "",
        },
        {
          num: "7.",
          name: "應用RFID辨識及ZigBee 傳輸之智慧型VIP點餐加值服務管理系統。",
          student_name: "(組長:曾婉茹、組員:賴俊穎、連敏秀、莊雅惠、吳佳玲)",
          awards: "",
          path: "",
        },
        {
          num: "8.",
          name: "智慧型生活空間應用以ZigBee 無線元件實作。",
          student_name: "(組長:鄭大偉、組員:江孟翰、施力瑋、鄭雁文、蔡蓮忠)",
          awards: "",
          path: "",
        },
        {
          num: "9.",
          name: "網際網路資訊安全之網路釣魚防治與檢測。",
          student_name: "(組長:李泓慶、組員:吳宗翰、邱思明、蘇柏瑞、張宸偉)",
          awards: "",
          path: "",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}
@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC_Regular", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
  cursor: pointer;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.ct1 {
  color: rgb(103, 38, 146);
}
.ct2 {
  color: blue;
}
.ct3 {
  color: coral;
}
.ct4 {
  color: red;
}
.ct5 {
  color: rgb(4, 174, 173);
}
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}

.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  font-family: "NotoSansTC_Bold";
  text-align: center;
  padding-bottom: 30px;
}
.section-title h2 {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #555;
}
.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# publicaiton
--------------------------------------------------------------*/
.studentAward-title {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 3vh;
  text-align: center;
}
.publicaiton-content {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #065654;
}
.studentawards-title {
  font-family: "NotoSansTC_Bold";
  color: #000000;
  font-size: 3vh;
  text-align: center;
}
.studentawards-content {
  font-family: "NotoSansTC_Regular";
  font-size: 2vh;
  text-align: left;
  color: #389402f1;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}
.about ul {
  list-style: none;
  padding: 0;
}
.about ul li {
  padding-bottom: 10px;
}
.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}
.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
